import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';
import CartGroupOrderItemsContainer from 'bento-ordering/group_ordering/containers/CartGroupOrderItemsContainer';
import { styled } from '@mui/system';
import { generatePath } from 'bento-ordering/utils/generatePath';
import { GROUP_ORDER } from 'bento-ordering/group_ordering/constants/entities';
import PrimaryCta from 'components/Buttons/PrimaryCta';
import GroupAddIcon from '@mui/icons-material/GroupAdd';

const StyledInviteButtonContainer = styled('div')`
  padding-top: 2rem;
  padding-bottom: 1rem;
`;

const GroupOrderAdminCartView = ({
  getEditCartItemPath,
  removeItemFromCart,
  handleEditClick,
  currentCartPath,
  adminDiner,
  guestDiners
}) => {
  const dispatch = useDispatch();
  const handleInvite = () => {
    const path = generatePath(GROUP_ORDER, 'groupOrderInvite');
    dispatch(push(path));
  };

  return (
    <>
      <StyledInviteButtonContainer>
        <PrimaryCta
          label="Invite"
          startIcon={<GroupAddIcon />}
          handleClick={handleInvite}
          fullWidth
        />
      </StyledInviteButtonContainer>
      <CartGroupOrderItemsContainer
        getEditCartItemPath={getEditCartItemPath}
        removeItemFromCart={removeItemFromCart}
        handleEditClick={handleEditClick}
        currentCartPath={currentCartPath}
        adminDiner={adminDiner}
        guestDiners={guestDiners}
      />
    </>
  );
};

GroupOrderAdminCartView.propTypes = {
  getEditCartItemPath: PropTypes.func,
  removeItemFromCart: PropTypes.func,
  handleEditClick: PropTypes.func,
  currentCartPath: PropTypes.string,
  adminDiner: PropTypes.object,
  guestDiners: PropTypes.array
};

export default GroupOrderAdminCartView;
